export class Language{
    id:number;
    language:string;
    code:string;
}